/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Auth_Mfa_Method_Email_DescriptionInputs */

const de_auth_mfa_method_email_description = /** @type {(inputs: Auth_Mfa_Method_Email_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.email}`)
};

/** @type {(inputs: Auth_Mfa_Method_Email_DescriptionInputs) => LocalizedString} */
const en_auth_mfa_method_email_description = de_auth_mfa_method_email_description;

/**

* @param {Auth_Mfa_Method_Email_DescriptionInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_mfa_method_email_description = /** @type {((inputs: Auth_Mfa_Method_Email_DescriptionInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Mfa_Method_Email_DescriptionInputs, { locale?: "de" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_mfa_method_email_description(inputs)
	return en_auth_mfa_method_email_description(inputs)
});